<div class="container">
  <div class="card mt-5">
    <div
      class="card-header d-flex flex-lg-row flex-column justify-content-between"
    >
      <h3 class="card-title">
        <i
          class="bi bi-arrow-left-circle"
          routerLink="/dashboard"
          style="cursor: pointer"
        ></i>
        Historial de alimentación - {{ user?.firstName }}&nbsp;{{
          user?.lastName
        }}
      </h3>

      <button
        class="btn-custom"
        data-bs-toggle="modal"
        data-bs-target="#dietFormModal"
        (click)="handleCreateDiet($event)"
      >
        Crear Dieta
      </button>
    </div>
    <div class="card-body">
      <div class="custom-accordion">
        <div class="custom-accordion-item" *ngFor="let diet of diets">
          <div class="custom-accordion-header">
            <button
              class="custom-accordion-button"
              [class.expanded]="isAccordionOpen(diet.id)"
              type="button"
              (click)="toggleAccordion(diet.id)"
            >
              <div>
                {{ diet.name }}

                <span
                  class="ms-2 created-progress-pill"
                  *ngIf="diet.status == 'CREATED'"
                  ><i class="bi bi-clock me-1"></i>Aun no en fecha</span
                >

                <span
                  class="ms-2 not-started-progress-pill"
                  *ngIf="diet.status == 'NOT_STARTED'"
                  ><i class="bi bi-journal me-1"></i>Sin registros</span
                >

                <span
                  class="ms-2 started-progress-pill"
                  *ngIf="diet.status == 'STARTED'"
                  ><i class="bi bi-utensils me-1"></i>En Progreso</span
                >

                <span
                  class="ms-2 finished-progress-pill"
                  *ngIf="diet.status == 'FINISHED'"
                  ><i class="bi bi-check-circle me-1"></i>Finalizada</span
                >
                <i
                  class="bi bi-pencil-square mx-lg-3 mx-2"
                  *ngIf="diet.status !== 'FINISHED'"
                  (click)="$event.stopPropagation(); editDiet(diet)"
                  data-bs-toggle="modal"
                  data-bs-target="#dietFormModal"
                ></i>
              </div>
              <i
                class="bi"
                [class.bi-chevron-down]="!isAccordionOpen(diet.id)"
                [class.bi-chevron-up]="isAccordionOpen(diet.id)"
              ></i>
            </button>
          </div>
          <div
            class="custom-accordion-content"
            [class.show]="isAccordionOpen(diet.id)"
            *ngIf="isAccordionOpen(diet.id)"
          >
            <div
              class="custom-accordion-body d-flex flex-column justify-content-end align-items-end"
            >
              <app-diet-detail
                [diet]="diet"
                [user]="user"
                (getUserDietsHistory)="getUserDietsHistory()"
              ></app-diet-detail>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-diet-form-modal
  [diet]="selectedDiet"
  (dietCreated)="onDietCreate($event)"
  (dietUpdated)="onDietCreate($event)"
></app-diet-form-modal>
